import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ProductTrackContributorAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('artist');
  }
}
